import { PaginationQuery, PaginationQueryDefaultValues } from "../../pagination/pagination-query"

export interface BBInvitationList
{
    id:string,
    caseId:string,
    email:string,
    coach:string,
    expiryDate:string,
    linkAccessed:string,
    status:string,
    statusDescription:string,
    
}

export function BBInvitationListDefaultValues():BBInvitationList
{
    return {id:'',caseId:'',email:'',coach:'',expiryDate:'',linkAccessed:'',status:'',statusDescription:''}
}


export type BBInvitationQuery = PaginationQuery & 
{
    InvitationSearchKeyword:string,
    Coach:number,
    Status:string,
}

export function BBInvitationQueryDefaultValues(): BBInvitationQuery
{
    return {InvitationSearchKeyword:'',Coach:0,Status:'',...PaginationQueryDefaultValues()}
}
